var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { BridgeType, PresaleContractType } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useEffect, useState } from 'react';
import { RoutePath, generateRoutePath } from '../../app/router/config';
import boredBoxImage from '../../assets/images/bridge/images/bored-box.png';
import legacyImage from '../../assets/images/bridge/images/legacy.png';
import legendaryPremiumImage from '../../assets/images/bridge/images/legendary-premium.png';
import legendaryStandardImage from '../../assets/images/bridge/images/legendary-standard.png';
import { UserContext } from '../../context/user';
import { useMetamask } from '../blockchain/use-metamask';
export var PresalePackTokenBurnStatus;
(function (PresalePackTokenBurnStatus) {
    PresalePackTokenBurnStatus["TO_DO"] = "to-do";
    PresalePackTokenBurnStatus["PENDING"] = "pending";
    PresalePackTokenBurnStatus["BRIDGED"] = "bridged";
    PresalePackTokenBurnStatus["FAILED"] = "failed";
})(PresalePackTokenBurnStatus || (PresalePackTokenBurnStatus = {}));
export function useBridge(fromAccount) {
    var t = useI18n().t;
    var user = useContext(UserContext).user;
    var _a = useMetamask(false, null), connectMetamask = _a.connectMetamask, userBalance = _a.userBalance, metamaskWalletAddress = _a.metamaskWalletAddress, metamaskConnected = _a.metamaskConnected, metamaskErrorMessage = _a.metamaskErrorMessage, isRequestPending = _a.isRequestPending, setMetamaskErrorMessage = _a.setMetamaskErrorMessage;
    var reconnectUser = useContext(UserContext).reconnectUser;
    var _b = useState(undefined), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = useState(false), initialized = _c[0], setInitalized = _c[1];
    useEffect(function () {
        initialize();
    }, []);
    var items = [
        {
            label: 'Legendary Standard',
            image: legendaryStandardImage,
            bridgeType: BridgeType.POLYGON_PRESALE,
            contractType: PresaleContractType.STANDARD,
            path: generateRoutePath(RoutePath.BRIDGE, {
                bridgeType: BridgeType.POLYGON_PRESALE,
                contractType: PresaleContractType.STANDARD,
            }),
        },
        {
            label: 'Legendary Premium',
            image: legendaryPremiumImage,
            bridgeType: BridgeType.POLYGON_PRESALE,
            contractType: PresaleContractType.PREMIUM,
            path: generateRoutePath(RoutePath.BRIDGE, {
                bridgeType: BridgeType.POLYGON_PRESALE,
                contractType: PresaleContractType.PREMIUM,
            }),
        },
        {
            label: 'Legacy',
            image: legacyImage,
            bridgeType: BridgeType.POLYGON_PRESALE,
            contractType: PresaleContractType.LEGACY,
            path: generateRoutePath(RoutePath.BRIDGE, {
                bridgeType: BridgeType.POLYGON_PRESALE,
                contractType: PresaleContractType.LEGACY,
            }),
        },
        {
            label: 'Bored Box',
            image: boredBoxImage,
            bridgeType: BridgeType.BORED_BOX,
            contractType: PresaleContractType.STANDARD,
            path: generateRoutePath(RoutePath.BRIDGE, {
                bridgeType: BridgeType.BORED_BOX,
                contractType: PresaleContractType.STANDARD,
            }),
        },
    ];
    function initialize() {
        if (window.ethereum && !fromAccount) {
            window.ethereum.on('chainChanged', connectMetamask);
            window.ethereum.on('accountsChanged', connectMetamask);
        }
        setInitalized(true);
    }
    function connectWalletHandler() {
        return __awaiter(this, void 0, void 0, function () {
            var accountsReq, walletId, nonceInfo, signedNonce, walletLinked;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.ethereum) return [3 /*break*/, 6];
                        return [4 /*yield*/, window.ethereum.request({ method: 'eth_requestAccounts' })];
                    case 1:
                        accountsReq = (_a.sent());
                        if (!accountsReq || accountsReq.length === 0) {
                            setErrorMessage(t('error.metamask-account-not-found'));
                            return [2 /*return*/];
                        }
                        walletId = accountsReq[0];
                        return [4 /*yield*/, gqlSdk.BridgeInitiateWalletLink({
                                input: { walletId: walletId },
                            })];
                    case 2:
                        nonceInfo = _a.sent();
                        if (!nonceInfo.bridgeInitiateWalletLink) {
                            setErrorMessage(t('error.cannot-get-nonce'));
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, window.ethereum.request({
                                method: 'personal_sign',
                                params: [walletId, nonceInfo.bridgeInitiateWalletLink.link],
                            })];
                    case 3:
                        signedNonce = _a.sent();
                        return [4 /*yield*/, gqlSdk.BridgeCompleteWalletLink({
                                input: { signedNonce: signedNonce },
                            })];
                    case 4:
                        walletLinked = _a.sent();
                        if (!walletLinked.bridgeCompleteWalletLink) {
                            setErrorMessage(t('error.wallet-link-failed'));
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, reconnectUser()];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        setErrorMessage(t('error.metamask-not-installed'));
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    function globalSetErrorMessage(value) {
        setMetamaskErrorMessage(value);
        setErrorMessage(value);
    }
    function getDisplayedStatus(status) {
        switch (status) {
            case PresalePackTokenBurnStatus.BRIDGED: {
                return t('bridge-status.bridged');
            }
            case PresalePackTokenBurnStatus.FAILED: {
                return t('bridge-status.failed');
            }
            case PresalePackTokenBurnStatus.PENDING: {
                return t('bridge-status.pending');
            }
            case PresalePackTokenBurnStatus.TO_DO: {
                return t('bridge-status.to-do');
            }
            default:
                return t('common.unknown');
        }
    }
    return {
        items: items,
        metamaskConnected: metamaskConnected,
        metamaskWalletAddress: metamaskWalletAddress,
        userBalance: userBalance,
        errorMessage: errorMessage || metamaskErrorMessage,
        initialized: initialized,
        metamaskReady: Boolean((user === null || user === void 0 ? void 0 : user.polygonWalletConfirmed) &&
            (user === null || user === void 0 ? void 0 : user.polygonWalletId) &&
            metamaskWalletAddress &&
            metamaskWalletAddress.toLowerCase() === user.polygonWalletId.toLowerCase()),
        isMetamaskRequestPending: isRequestPending,
        connectMetamask: connectMetamask,
        connectWalletHandler: connectWalletHandler,
        setErrorMessage: globalSetErrorMessage,
        getDisplayedStatus: getDisplayedStatus,
    };
}
